export default __webpack_public_path__ + "static/media/Chanchanapathi.c7089324.png";